export default {
  name: 'cmdb',
  translationKey: 'asset-module',
  routePrefix: 'cmdb',
  routeNamePrefix: 'cmdb',
  directRoutesAvailable: true,
}
